import {createSlice, PayloadAction} from '@reduxjs/toolkit'

interface SidebarState {
    isMini: boolean;
    title: string;
}

const initialSidebarState: SidebarState = {
    isMini: false,
    title: ''
}

export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: initialSidebarState,
    reducers: {
        setMiniSidebar: (state, action: PayloadAction<boolean>) => {
            state.isMini = action.payload;
            localStorage.setItem('is-mini', action.payload ? 'true' : 'false');
        },
        setSidebarTitle: (state, action: PayloadAction<string>) => {
            state.title = action.payload;
        }
    }
})

export const {setMiniSidebar, setSidebarTitle} = sidebarSlice.actions
export default sidebarSlice.reducer
